module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hollandsnieuwe-03.e040a617.jpg";